//navbar

import React from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import styles from "./index.module.css";
import Logo from "../assets/logo_irrigacion.png";
import { ROUTES } from "../routes";

const MainNav = () => {
    return (
        <Navbar className={styles.mainNav} >
            <Container>
                <Navbar.Brand href="https://www.irrigacion.gov.ar/web/"><img src={Logo} className={styles.logo} /> <span style={{ color: "white", fontWeight: "700" }}></span></Navbar.Brand>
                <Nav className={styles.navLinks} style={{ color: "white" }}>
                    <Nav.Link as={Link} to={ROUTES.home.path}><i className="fa fa-home"></i></Nav.Link>
                    
                </Nav>
            </Container>
        </Navbar>

    );
};

export default MainNav;